'use client';

import { InverseHeader } from '@jouzen/ecom-components/layout';
import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';

import useScrollTracking from '@/app/hooks/useScrollTracking';

import ActivityAndMovementFeatures from './_components/ActivityAndMovementFeatures';
import ActivityAndMovementFooter from './_components/ActivityAndMovementFooter';
import ActivityAndMovementHero from './_components/ActivityAndMovementHero';
import ActivityAndMovementIntegrations from './_components/ActivityAndMovementIntegrations';
import ActivityAndMovementJumbotron from './_components/ActivityAndMovementJumbotron';
import ActivityAndMovementTestimonials from './_components/ActivityAndMovementTestimonials';
import ActivityAndMovementTracking from './_components/ActivityAndMovementTracking';
import activityAndMovementPageGradients from './_data/activityAndMovementPageGradients';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <section>
      <InverseHeader>
        <RadialGradientBG
          className="bg-cream-50"
          gradients={activityAndMovementPageGradients}
        >
          <ActivityAndMovementHero />
          <ActivityAndMovementFeatures />
          <ActivityAndMovementTracking />
          <ActivityAndMovementJumbotron />
          <ActivityAndMovementTestimonials />
          <ActivityAndMovementIntegrations />
        </RadialGradientBG>
        <ActivityAndMovementFooter />
      </InverseHeader>
    </section>
  );
};

export default Content;
